import { useQuery } from '@tanstack/react-query';
import { UsersService } from '../services';
import { usersKeys } from '../queryKeys';

/**
 * One user's NPS answers for the profile's NPS tab, from auth-service.
 *
 * Disabled until the profile has resolved the user's id. That wait reads as
 * pending, not as an empty list, so the tab never claims "No NPS" for a user it
 * has not asked about yet.
 *
 * `retry: false` so a failure reaches the tab's error state on the first
 * attempt, as the profile's other tab queries do. `skipGlobalErrorToaster`
 * because the tab renders that error inline; without it `queryClient` also
 * raises a toast, and one failure reports twice.
 *
 * @param {string} [userId] - Absent while the profile is still loading
 */
export const useGetNpsReviews = (userId) => {
  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: usersKeys.npsReviews(userId),
    queryFn: () => UsersService.getNpsReviews(userId),
    enabled: Boolean(userId),
    retry: false,
    refetchOnWindowFocus: false,
    meta: { skipGlobalErrorToaster: true },
  });

  return {
    rows: data ?? [],
    isPending: isLoading || !userId,
    isError,
    refetch,
  };
};
